import useSimDetails from 'api/sims/useSimDetails';
import { useCallback, useMemo } from 'react';
import type { DropdownItemEntry, ManageSimItemHook } from '../types';

const useResumeSims: ManageSimItemHook = ({
  context,
  segmentName,
  selectedSims,
  handleModalOpen,
  onActionTaken,
  onSimsModified,
  disabled,
}) => {
  const simId = context === 'details' && selectedSims ? [...selectedSims.keys()][0] : undefined;
  const onClick = useCallback(() => {
    handleModalOpen({
      modalName: 'SimInventoryBulkUpdateStateModal',
      modalProps: { action: 'resume', sims: selectedSims, onModalSuccess: onSimsModified },
    });
    onActionTaken();
  }, [onActionTaken, handleModalOpen, onSimsModified, selectedSims]);

  const { simDetails } = useSimDetails(context === 'details' && simId ? simId : undefined);

  const show =
    (context === 'inventory' && ['active', 'all'].includes(segmentName ?? '')) ||
    (!!simId && simDetails.networkStatus?.localeCompare('PAUSED-USER') === 0);

  return useMemo<DropdownItemEntry | false>(
    () =>
      show && {
        children: 'Resume data usage...',
        iconStart: 'Play',
        disabled,
        onClick,
        id: `sim${context}-dataplan-resume`,
      },
    [context, disabled, onClick, show]
  );
};

export default useResumeSims;
